import type { Entity } from '@backstage/catalog-model';

/** Anotaciones propias de IMJ Media para gobernanza de aplicaciones. */
export const WIB_CRITICALITY = 'wib/criticality';
export const WIB_SPOF = 'wib/spof-impact';
export const WIB_TECH_DEBT = 'wib/tech-debt';
export const WIB_MIGRATION = 'wib/migration-status';
export const WIB_DEPLOYMENT_MODE = 'wib/deployment-mode';
export const WIB_DEPLOYMENT_HOST = 'wib/deployment-host';
export const WIB_PROD_STATUS = 'wib/prod-status';
export const WIB_MIGRATION_BLOCKER = 'wib/migration-blocker';

/** Anotaciones estándar de Backstage usadas por los indicadores de salud. */
export const BACKSTAGE_TECHDOCS_REF = 'backstage.io/techdocs-ref';
export const BACKSTAGE_ADR_LOCATION = 'backstage.io/adr-location';

/**
 * Lee una anotación de la entidad y devuelve su valor sin espacios.
 * Devuelve `undefined` si no existe o está vacía.
 */
export function readAnnotation(
  entity: Entity,
  key: string,
): string | undefined {
  const valor = entity.metadata.annotations?.[key]?.trim();
  return valor ? valor : undefined;
}

/** Anotaciones de despliegue (Dokploy, repositorio, entornos). */
export const DOKPLOY_APPLICATION_ID = 'dokploy.com/application-id';
export const DOKPLOY_PROJECT = 'dokploy.com/project';
export const DOKPLOY_TYPE = 'dokploy.com/type';
export const WIB_PORT = 'wib/port';
export const WIB_CERT = 'wib/cert';
export const BACKSTAGE_SOURCE_LOCATION = 'backstage.io/source-location';
export const BACKSTAGE_DEV_URL = 'backstage.io/dev-url';
export const BACKSTAGE_STAGING_URL = 'backstage.io/staging-url';
export const BACKSTAGE_PROD_URL = 'backstage.io/prod-url';
export const GITHUB_PROJECT_SLUG = 'github.com/project-slug';
export const BITBUCKET_PROJECT_SLUG = 'bitbucket.org/project-slug';
